module.exports = __webpack_public_path__ + "static/media/add-icon.c7e7d401.png";